import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import {
  ThomasAdvertiserData,
  ThomasAdvertiserDataReduced,
  ThomasAdvertiserReduced
} from 'models/interfaces';
import { AdvertisersPageCache } from 'models/interfaces/PageCache';

export const GET_ADVERTISERS_QUERY = gql`
  query ThomasAdvertisers {
    thomasAdvertisers {
      tgrams_id
      name
    }
  }
`;

export const LIST_ADVERTISERS_REDUCED_QUERY = gql`
  query ListThomasAdvertisersReduced(
    $sortKey: String
    $sortDirection: String
    $searchTerm: String
    $size: Int
    $from: Int
    $productId: String
  ) {
    thomasAdvertisersReduced(
      sortKey: $sortKey
      sortDirection: $sortDirection
      searchTerm: $searchTerm
      size: $size
      from: $from
      productId: $productId
    ) {
      thomasAdvertiserReducedList {
        name
        tgrams_id
        status_id
        campaigns
        product_id
      }
      queryInfo {
        resultsCount
        success
        message
      }
    }
  }
`;

interface ThomasAdvertiserListQueryResults {
  thomasAdvertisers?: ThomasAdvertiserData[];
  thomasAdvertisersReduced?: ThomasAdvertiserDataReduced;
  loading: boolean;
}

interface ThomasAdvertiserListContainerVariables {
  sortKey: string;
  sortDirection: string;
  searchTerm: string;
  size: number;
  from: number;
  productId: string;
}

interface ThomasAdvertiserListContainerResults {
  thomasAdvertisers: ThomasAdvertiserData[];
  thomasAdvertisersReduced: ThomasAdvertiserReduced[];
  loading: boolean;
  resultsCount?: number;
}

interface ThomasAdvertiserListContainerProps {
  children: (props: ThomasAdvertiserListContainerResults) => any;
  productId: string;
  advertisersPageCache: AdvertisersPageCache;
}

// class ThomasAdvertisersQuery extends Query<
//   ThomasAdvertiserListQueryResults,
//   ThomasAdvertiserListContainerVariables
// > {}

const ThomasAdvertiserListContainer: React.FunctionComponent<
  ThomasAdvertiserListContainerProps
> = ({ children, productId, advertisersPageCache }) => {
  const {
    activeSort: { sortKey, sortDirection },
    searchTerm,
    from,
    size
  } = advertisersPageCache;
  let query = LIST_ADVERTISERS_REDUCED_QUERY;
  if (size !== null && from !== null) {
    // size = 25;
    // from = 0;
  }
  return (
    <Query<ThomasAdvertiserListQueryResults, ThomasAdvertiserListContainerVariables>
      query={query}
      variables={{ sortKey, sortDirection, searchTerm, size, from, productId }}
    >
      {({ data: { thomasAdvertisers, thomasAdvertisersReduced } = {}, loading }) => {
        if (loading) {
          return null;
        }
        console.log('thomasAdvertisersReduced ', thomasAdvertisersReduced);

        let resultsCount = 0;
        let thomasAdvertisersReducedList: ThomasAdvertiserReduced[] = [];
        if (
          thomasAdvertisersReduced !== undefined &&
          thomasAdvertisersReduced.queryInfo !== undefined
        ) {
          thomasAdvertisersReducedList = thomasAdvertisersReduced.thomasAdvertiserReducedList;
          resultsCount = thomasAdvertisersReduced.queryInfo.resultsCount;
        }
        if (sortKey === 'thomasCampaigns') {
          thomasAdvertisers &&
            thomasAdvertisers.sort((a, b) => {
              if (sortDirection === 'ASC') {
                return a.thomasCampaignCount - b.thomasCampaignCount;
              } else {
                return b.thomasCampaignCount - a.thomasCampaignCount;
              }
            });
        }

        return (
          children &&
          children({
            thomasAdvertisers: thomasAdvertisers || [],
            thomasAdvertisersReduced: thomasAdvertisersReducedList,
            loading,
            resultsCount
          })
        );
      }}
    </Query>
  );
};

export default ThomasAdvertiserListContainer;
